import {ColorImgType, SideStone, SliderContent} from '../types';
import {
  ElongatedCushion,
  Emerald,
  Marquise,
  Oval,
  Pear,
  Princess,
  Radiant,
  RoseGold,
  Round,
  SilverGold,
  YellowGold,
  NaturalDiamond,
  LabBlueSapphire,
  LabEmerald,
  LabRuby,
  SquareCushion,
  DiamondHeart
} from '../components/Images';

export const colorName: { [key: string]: string } = {
  WG: 'White',
  YG: 'Yellow',
  RG: 'Rose',
};

export const ColorImg: ColorImgType = {
  "White": SilverGold,
  "Yellow": YellowGold,
  "Rose": RoseGold,
};
export const PDPColorImage: ColorImgType = {
  "WG": SilverGold,
  "YG": YellowGold,
  "RG": RoseGold,
};
export const SideStones: SideStone = {
  'LRB':LabRuby,
  'LEM':LabEmerald,
  'DIA':NaturalDiamond,
  'LBS':LabBlueSapphire,
};
export const DiamondShapeContent: SliderContent[] = [
  {
    imgPath: Oval,
    label: "Oval",
    code: 'OVA'
  },
  {
    imgPath: Round,
    label: "Round",
    code: 'RND'
  },
  {
    imgPath: Radiant,
    label: "Radiant",
    code: 'RAD'
  },
  {
    imgPath: ElongatedCushion,
    label: 'Elongated Cushion',
    code: 'CUS'
  },
  {
    imgPath: Princess,
    label: "Princess",
    code: 'PRC'
  },
  {
    imgPath: Emerald,
    label: "Emerald",
    code: 'EMR'
  },
  {
    imgPath: Pear,
    label: "Pear",
    code: 'PEA'
  },
  {
    imgPath: Marquise,
    label: "Marquise",
    code: 'MAR'
  },
  {
    imgPath: DiamondHeart,
    label: "Heart",
    code: 'HRT'
  },
  {
    imgPath: SquareCushion,
    label: "Square Cushion",
    code: 'SCU'
  },
  /*{
    imgPath: Cushion,
    label: "Cushion",
    code: 'CUS'
  },
  {
    imgPath: Asscher,
    label: "Asscher",
    code: 'ASC'
  },*/
  /*{
      imgPath: Heart,
      label: "Heart",
      code: 'HAT'
  }*/
];

export const DiamondLabels :{[key:string]:string} ={
  Round:"Round",
  Princess:"Princess-Cut",
  Pear:"Pear-Shaped",
  Oval:"Oval",
  Emerald:"Emerald-Cut",
  Radiant:"Radiant-Cut",
  Marquise:"Marquise-Cut",
  Cushion:"Cushion-Cut",
  'Elongated Cushion':"Elongated Cushion-Cut",
  Heart:"Heart-Shaped",
  'Square Cushion':"Square Cushion-Cut",
}

export const weddingButton = [
  {
    "Code": "14_WG",
    "Name": "14K White"
  },
  {
    "Code": "14_YG",
    "Name": "14K Yellow"
  },
  {
    "Code": "14_RG",
    "Name": "14K Rose"
  },
  {
    "Code": "18_WG",
    "Name": "18K White"
  },
  {
    "Code": "18_YG",
    "Name": "18K Yellow"
  },
  {
    "Code": "18_RG",
    "Name": "18K Rose"
  },
  {
    "Code": "PT_WG",
    "Name": "Platinum"
  }
]
